import React from 'react';
import ReactDOM from 'react-dom';
import UsaMap from 'UsaMap';
import BusinessPlanHeader from '../headers/BusinessPlanHeader';
import BusinessPlanFooter from '../footers/BusinessPlanFooter';
import BusinessPlanToolTip from '../tooltips/BusinessPlanToolTip';
import BusinessPlanMobileFooter from '../mobile-footers/BusinessPlanMobileFooter';
import BusinessPlanMobileHeader from '../mobile-headers/BusinessPlanMobileHeader';

export default class BusinessPlanLandingMap extends React.Component {
  static init(id, props) {
    ReactDOM.render(
      <UsaMap
        {...props}
        headerTemplate={<BusinessPlanHeader {...props} />}
        footerTemplate={<BusinessPlanFooter {...props} />}
        renderTooltipTemplate={newProps => (<BusinessPlanToolTip {...newProps} />)}
        renderMobileTooltipTemplate={newProps =>
          (<BusinessPlanToolTip {...newProps} />)}
        mobileSelectHeaderTemplate={<BusinessPlanMobileHeader {...props} />}
        renderMobileSelectFooterTemplate={stateCreationClickHandler => (
          <BusinessPlanMobileFooter
            stateCreationClickHandler={stateCreationClickHandler}
            {...props}
          />
        )}
      />,
      document.getElementById(id),
    );
  }
}



// WEBPACK FOOTER //
// ./src-react/UsaMap/containers/BusinessPlanLandingMap.jsx